<template>
  <de-layout-content>
    <!-- <el-card class="height-full venueIndex"> -->
    <div class="venueIndex">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="预约审核" name="subscribe">
          <!-- <el-empty description="正在开发中..."></el-empty> -->
          <subscribe></subscribe>
        </el-tab-pane>
        <el-tab-pane label="场馆管理" name="venue">
          <venueManage></venueManage>
        </el-tab-pane>
        <el-tab-pane label="科技服务" name="serve">
          <techServe></techServe>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- </el-card> -->
  </de-layout-content>
</template>

<script>
import moment from "moment";
import venueManage from "./manage.vue";
import techServe from "./serve.vue";
import subscribe from "./subscribe.vue";
export default {
  components: {
    venueManage,
    techServe,
    subscribe
  },
  data(){
    return {
      activeName: "subscribe",
    }
  },
  computed: {
    changeTime(){
      return function(time, type){
        type = type ? type : 'YYYY-MM-DD hh:mm:ss'
        return moment(time).format(type)
      }
    },
    videoTime(){
      return function(mss) {
        var days = parseInt(mss / (1000 * 60 * 60 * 24));
        var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = parseInt((mss % (1000 * 60)) / 1000);
        if (days > 0) {
          return `${days}天${hours<10 ? '0'+hours : hours}小时${minutes<10 ? '0'+minutes : minutes}分钟${seconds<10 ? '0'+seconds : seconds}秒`
        }
        if (hours > 0) {
          return `${hours<10 ? '0'+hours : hours}:${minutes<10 ? '0'+minutes : minutes}:${seconds<10 ? '0'+seconds : seconds}`
        }
        return `${minutes<10 ? '0'+minutes : minutes}:${seconds<10 ? '0'+seconds : seconds}`
      }
    },
    moment: () => moment,
    formatLength() {
      return (num) => {
        const min = Math.floor(parseInt(num) / 1000 / 60);
        const sec = Math.floor(parseInt(num) / 1000 - 60 * min);
        return `${min.toString().padStart(2, "0")}:${sec
          .toString()
          .padStart(2, "0")}`;
      };
    },
  },
  methods: {
    moment,
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
  created(){
    
  }
}
</script>

<style lang="less" scoped>
.full-height {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px) !important;
  padding-bottom: 40px;
}
</style>
<style lang="less">
// .venueIndex.el-card {
//   background-color: #0f132a;
// }
.venueIndex {
  height: 100%;
  width: 100%;
  max-width: 1600px;
  .el-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .el-tabs__content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }
  .el-tab-pane {
    height: 100%;
  }
}
</style>